<template>
  <b-overlay
    :show="loader"
    rounded="sm"
  >
    <div v-if="detalle!==null">
      <b-row>
        <b-col
          md="6"
          sm="12"
        >
          <p> {{ nombre }}</p>
          <p> Matricula: <b>{{ mat }}</b></p>
          <p> Plan: {{ detalle.nombre }}</p>
          <p>Estado de la Solicitud Actual:
            <b-badge
              :variant="`${resolveTipoEstado(estado)}`"
              pill
              class="badge-round"
            > <small>{{ resolveEstadoNombre(estado) }}</small>
            </b-badge>
          </p>
          <p>Tipo de baja:
            <b-badge
              :variant="`${resolveTipoBajaVariant(tipo)}`"
              pill
              class="badge-round"
            > <small>{{ resolveTipoNombre(tipo) }}</small>
            </b-badge>
          </p>

        </b-col>
        <b-col
          md="6"
          sm="12"
        >
          <p>Número de Solicitud : <b>{{ sol }}</b></p>
          <p> Estado del alumno para esta agenda: <b>{{ detalle.descripcion }}</b></p>
          <p> Número de agendas: <b>{{ detalle.numeroagendas }}</b></p>
          <p> Plazo Máximo del plan: <b>{{ detalle.plazoMax }} meses</b></p>
          <p> Generación: <b>{{ detalle.generacion }}</b></p>
        </b-col>
      </b-row>

      <b-row class="mb-2">
        <b-col>
          <p
            v-if="estado !== null"
            class="text-center"
          >
            Esta solicitud ya ha sido <b class="text-primary">procesada. No es posible invertir el cambio</b>, si se ha equivocado, porfavor contactar al área de sistemas.
          </p>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col>

          <hr>
          <b-form v-if="estado === null">
            <b-form-group>
              <b-form-radio
                v-model="radioResolucion"
                class="custom-control-primary"
                name="some-radios3"
                :value="1"
              >
                Aceptar Solicitud
              </b-form-radio>
              <b-form-radio
                v-model="radioResolucion"
                class="custom-control-danger"
                name="some-radios3"
                :value="0"
              >
                Rechazar Solicitud
              </b-form-radio>
              <label
                class=" mt-2"
                for="solicitud"
              >Razón de la Resolución *</label>
              <b-form-textarea
                id="textarea-solicitud"
                v-model="textareaResolucion"
                placeholder="Escriba aquí por lo menos 10 caracteres"
                :state="textareaResolucion.length >= 10"
                rows="3"
                max-rows="8"
              />
              <label for="solicitud">Comentarios del Consejo (opcional):</label>
              <b-form-textarea
                id="textarea-solicitud"
                v-model="textareaConsejo"
                placeholder="Escriba aquí (campo opcional)"
              />
              <b-form-checkbox
                v-if="tipo==='BD' && radioResolucion === 1"
                v-model="selectedPenalizacion"
                :value="1"
                class="custom-control-danger"
              >
                <b class="text-danger">Penalización Máxima (El usuario sera bloqueado de Campus Virtual Indetec)</b>
              </b-form-checkbox>
              <br>
              <p class="text-center">
                <b>Importante</b>,
                Una vez que haya sido <b>Aceptada</b> la solicitud, <b class="text-primary">No será posible realizar cambios</b> (sin intervención del área de sistemas).
              </p>
              <b-button
                class="mr-2"
                variant="primary"
                @click.prevent="validationForm"
              >
                Enviar
              </b-button>
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </b-overlay>
</template>

<script>
import store from '@/store'
import {
  BBadge, BForm, BFormGroup, BFormTextarea, BFormRadio, BOverlay, BFormCheckbox, BRow, BCol, BButton,
} from 'bootstrap-vue'
import {
  onMounted, ref, getCurrentInstance,
} from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { configTableAlumnosBajas, useBajasDetalle } from './useBaja'

export default {
  components: {
    BBadge, BForm, BFormGroup, BFormTextarea, BFormRadio, BOverlay, BFormCheckbox, BRow, BCol, BButton,
  },
  props: {
    sol: {
      type: [Number, null],
      default: null,
    },
    ag: {
      type: [Number, null],
      default: null,
    },
    estado: {
      type: [Number, null],
      default: null,
    },
    tipo: {
      type: [String, null],
      default: null,
    },
    mat: {
      type: [Number, null],
      default: null,
    },
    nombre: {
      type: [String, null],
      default: null,
    },
  },
  setup(props, { emit }) {
    const vm = getCurrentInstance().proxy
    const loader = ref(false)
    const detalle = ref(null)
    const toast = useToast()
    const {
      detallePromise,
    } = useBajasDetalle(props.ag)
    const radioResolucion = ref(null)
    const textareaResolucion = ref('')
    const textareaConsejo = ref(null)
    const selectedPenalizacion = ref(0)
    const {
      resolveTipoBajaVariant,
      resolveTipoNombre,
      resolveTipoEstado,
      resolveEstadoNombre,
    } = configTableAlumnosBajas()
    const submitForm = () => {
      const datasent = {
        resolucion: radioResolucion.value,
        justificacion: textareaResolucion.value,
        id: props.sol,
        consejo: textareaConsejo.value,
        penalizacion: selectedPenalizacion.value,
      }
      store.dispatch('bajas/postDatosResSol', { data: datasent })
        .then(response => {
          vm.$swal({
            icon: 'success',
            allowOutsideClick: false,
            title: 'Solicitud Editada',
            html: `${response.message}`,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
          emit('res', true)
        }, error => {
          vm.$swal({
            icon: 'error',
            allowOutsideClick: false,
            title: 'Lo sentimos - error de servicio',
            html: `${error}`,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        })
    }
    const validationForm = () => {
      emit('res', false)
      let mensaje = ''
      if (props.sol === null) mensaje += 'No se ha seleccionado ninguna solicitud de baja.'
      if (radioResolucion.value === null) mensaje += ' Selecciona si Aceptas o Rechazas la solicitud de baja.'
      if (textareaResolucion.value.length < 10) mensaje += ' Completa el texto - Razón de la Resolución. min 10 Caracteres'
      if (mensaje === '') {
        vm.$swal({
          icon: 'warning',
          allowOutsideClick: false,
          title: '¿Procesar solicitud?',
          html: 'Al dar click ya no se podrán hacer cambios sin intervención del área de sistemas',
          showCancelButton: true,
          confirmButtonText: 'Continuar',
          cancelButtonText: 'Cancelar',
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger ml-1',
          },
        }).then(result => {
          if (result.value) { submitForm() }
        })
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: mensaje,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 2000 })
      }
    }
    onMounted(() => {
      loader.value = true
      Promise.all([detallePromise])
        .then(values => {
          const [[d]] = values
          detalle.value = d
          loader.value = false
        })
        .catch(error => {
          loader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error del servicio',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    })
    return {
      resolveTipoBajaVariant,
      resolveTipoNombre,
      resolveTipoEstado,
      resolveEstadoNombre,
      detalle,
      radioResolucion,
      textareaResolucion,
      textareaConsejo,
      loader,
      selectedPenalizacion,
      validationForm,
    }
  },
}
</script>
